import { Component, inject, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ReferenceDataService } from '../../../services/reference-data.service';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { PhoneType } from '../../../models/enums';

export interface PhoneNumberForm {
  id: FormControl<number | null>;
  rawNumber: FormControl<string | null>;
  e164: FormControl<string | null>;
  type: FormControl<PhoneType | null>;
  countryIsoCode: FormControl<string | null>;
}

export function createPhoneNumberFormGroup(required: boolean): FormGroup<PhoneNumberForm> {
  return new FormGroup<PhoneNumberForm>(
    {
      id: new FormControl<number | null>(null),
      rawNumber: new FormControl(''),
      e164: new FormControl(''),
      type: new FormControl(PhoneType.LANDLINE),
      countryIsoCode: new FormControl('BEL')
    },
    {}
  );
}

@Component({
  selector: 'app-phone-number',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule
  ],
  templateUrl: './phone-number.component.html',
  styleUrl: './phone-number.component.scss',
})
export class PhoneNumberComponent {
  @Input({ required: true }) formGroup!: FormGroup;
  @Input() required = false;

  readonly refDataService = inject(ReferenceDataService);
  readonly countries = this.refDataService.getCountries();

  constructor() { }

  ngOnInit() { }
}
